export const dateToString = (date) => {
  const dateObject = new Date(date);

  const options = { day: "numeric", month: "short", year: "numeric" };
  return dateObject.toLocaleDateString("en-US", options);
};

export const dateCalculations = (date) => {
  const expiryDateString = date;

  const expiryDate = new Date(expiryDateString);

  const currentDate = new Date();

  const differenceInMillis = expiryDate - currentDate;

  const differenceInDays = differenceInMillis / (1000 * 60 * 60 * 24);

  const day = expiryDate.getDate();
  const month = expiryDate.toLocaleString("default", { month: "short" });

  return {
    days_until: differenceInDays.toFixed(0),
    day: day,
    month: month,
  };
};

export function formatTimestamp(timestampString) {
  const dateTime = new Date(timestampString);

  const dateOptions = { year: "numeric", month: "long", day: "numeric" };
  const timeOptions = {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  };

  const dateString = dateTime.toLocaleDateString(undefined, dateOptions);
  const timeString = dateTime.toLocaleTimeString(undefined, timeOptions);

  return {
    date: dateString,
    time: timeString,
  };
}
